const TEST_RANGE = [0, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000];

const ENGINE_POWER_RANGE = {
  uk: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1200],
  fr: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1200],
  de: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900],
};

export { TEST_RANGE, ENGINE_POWER_RANGE };
